// extracted by mini-css-extract-plugin
module.exports = {"card":"ValueCard_card__kAF68","solid":"ValueCard_solid__6vQ8t","gradient":"ValueCard_gradient__UHM27","text":"ValueCard_text__7BW3O"};